import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CallButton from "@/components/CallButton";
import { waLink, telHref, waMessages } from "@/lib/whatsapp";
import { useSite } from "@/context/SiteContext";
import { trackEvent } from "@/lib/analytics";
import { MessageCircle, Phone } from "lucide-react";

export default function PublicLayout({ children }) {
  const { whatsappNumber, settings } = useSite();
  const phone = settings?.phone || "07448743318";
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />

      {/* Floating Call + WhatsApp (desktop + mobile) */}
      <div className="fixed bottom-20 right-4 z-40 flex flex-col gap-3 md:bottom-6 md:right-6">
        <a
          data-testid="floating-call"
          href={telHref(phone)}
          onClick={() => trackEvent("phone_click", { context: "floating" })}
          aria-label="Call us"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-ink text-white shadow-lg transition-transform hover:scale-105"
        >
          <Phone className="h-6 w-6" />
        </a>
        <a
          data-testid="floating-whatsapp"
          href={waLink(whatsappNumber, waMessages.general())}
          onClick={() => trackEvent("whatsapp_click", { context: "floating" })}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp us"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105"
        >
          <MessageCircle className="h-7 w-7" />
        </a>
      </div>

      {/* Sticky mobile CTA — Call + WhatsApp */}
      <div className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-white/90 p-3 backdrop-blur-xl md:hidden">
        <div className="flex gap-2">
          <CallButton className="flex-1" size="md" variant="dark" context="sticky-mobile" testid="sticky-mobile-call">
            Call Us
          </CallButton>
          <WhatsAppButton className="flex-1" size="md" message={waMessages.general()} context="sticky-mobile" testid="sticky-mobile-whatsapp">
            WhatsApp
          </WhatsAppButton>
        </div>
      </div>
      <div className="h-20 md:hidden" />
    </div>
  );
}
